import {Component} from "react";
import SectionTitle from "../SectionTitle";
import "./SocialObjectsStyles.css"
import DisplayScreens from "../DisplayScreens";
import FancyNavigation from "../ScrollSpyPagination/PaginationNavigation";
import Fade from 'react-reveal/Fade';

class SocialObjects extends Component {
    constructor() {
        super();
        this.state = {
            titleWidth: window.innerWidth <= 768 ? 80 : 45,
            images: ['./szo/CN_SZO_1.svg', './szo/CN_SZO_1.png', './szo/CN_SZO_2.svg', './szo/CN_SZO_2.png', './szo/CN_SZO_3.svg', './szo/CN_SZO_3.png'],
            isRetina: window.devicePixelRatio >= 2
        }
        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
        window.addEventListener("resize", this.handleResize);
    }

    handleResize() {
        if (window.innerWidth <= 768) {
            this.setState({titleWidth: 80});
        } else {
            this.setState({titleWidth: 45});
        }
    }

    render() {
        let screen1 = this.state.isRetina ? this.state.images[1] : this.state.images[0];
        let screen2 = this.state.isRetina ? this.state.images[3] : this.state.images[2];
        let screen3 = this.state.isRetina ? this.state.images[5] : this.state.images[4];
        return (
            <div className={"social-objects"}>
                <FancyNavigation/>
                <SectionTitle title={"Находите ближайшие социально значимые объекты на карте"}
                              width={this.state.titleWidth}/>
                <div className={"social-objects-container"}>
                    <div className={"social-objects-screenshots"}>
                        <div className={"social-objects-screenshots-screen1 scr1"}>
                            <Fade delay={2100}>
                                <DisplayScreens screen={screen1}/>
                            </Fade>
                        </div>
                        <div className={"social-objects-screenshots-screen2 scr2"}>
                            <Fade delay={1400}>
                                <DisplayScreens screen={screen2}/>
                            </Fade>
                        </div>
                        <div className={"social-objects-screenshots-screen3 scr3"}>
                            <Fade delay={700}>
                                <DisplayScreens screen={screen3}/>
                            </Fade>
                        </div>
                    </div>
                    <div className={"social-objects-info"}>
                        <ul className={"social-objects-info_list"}>
                            <li className={"social-objects-info_list_item"}>Поиск социально значимых объектов</li>
                            <li className={"social-objects-info_list_item"}>Фильтрация точек приема электронного
                                сертификата ТСР по видам ТСР
                            </li>
                        </ul>
                    </div>
                </div>
                <div className={"social-objects-map-icon icon1"}>
                    <Fade delay={500}>
                        <img src={process.env.PUBLIC_URL + './icons/227.svg'}/>
                    </Fade>
                </div>
                <div className={"social-objects-map-icon icon2"}>
                    <Fade delay={500}>
                        <img src={process.env.PUBLIC_URL + './icons/206.svg'}/>
                    </Fade>
                </div>
                <div className={"social-objects-map-icon icon3"}>
                    <Fade delay={700}>
                        <img src={process.env.PUBLIC_URL + './icons/236.svg'}/>
                    </Fade>
                </div>
                <div className={"social-objects-map-icon icon4"}>
                    <Fade delay={700}>
                        <img src={process.env.PUBLIC_URL + './icons/238.svg'}/>
                    </Fade>
                </div>
                <div className={"social-objects-map-icon icon6"}>
                    <Fade delay={900}>
                        <img src={process.env.PUBLIC_URL + './icons/235.svg'}/>
                    </Fade>
                </div>
                <div className={"social-objects-map-icon icon7"}>
                    <Fade delay={1000}>
                        <img src={process.env.PUBLIC_URL + './icons/195.svg'}/>
                    </Fade>
                </div>
                <div className={"social-objects-map-icon icon8"}>
                    <Fade delay={900}>
                        <img src={process.env.PUBLIC_URL + './icons/234.svg'}/>
                    </Fade>
                </div>
                <div className={"social-objects-map-icon icon9"}>
                    <Fade delay={700}>
                        <img src={process.env.PUBLIC_URL + './icons/239.svg'}/>
                    </Fade>
                </div>
                <div className={"social-objects-map-icon icon10"}>
                    <Fade delay={1000}>
                        <img src={process.env.PUBLIC_URL + './icons/213.svg'}/>
                    </Fade>
                </div>
                <div className={"social-objects-map-icon icon11"}>
                    <Fade delay={1100}>
                        <img src={process.env.PUBLIC_URL + './icons/215.svg'}/>
                    </Fade>
                </div>
            </div>
        );
    }
}

export default SocialObjects;